export default {
  meta: {
    title: '新增商圈'
  }
};
